import { Grid } from '@mui/material'

import AddressEditForm from './AddressEditForm'

export default function AddressList({ path, fields, control, append, ...props }) {
  return (
    <Grid container spacing={2}>
      {fields.map((item, index) => (
        <AddressEditForm
          key={item.id}
          path={path}
          fields={fields}
          control={control}
          append={append}
          item={item}
          index={index}
          {...props}
        />
      ))}
    </Grid>
  )
}
